var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgF12020 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 300 300",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M76.617 155.088 43.933 187H2l52.108-51.646C73.38 116.083 82.783 113 115.775 113H246.2l-28.367 27.75h-98.358c-24.667 0-29.908 1.85-42.858 14.338Zm137.054-10.021h-93.579c-24.821 0-28.675 1.85-39.93 13.104L51.487 187h38.85l9.25-9.25c6.167-6.167 8.788-6.629 21.121-6.629h67.063l25.9-26.054ZM223.846 187 298 113h-46.096l-74 74h45.942Z"
})));
export default SvgF12020;